'use client';

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';

import BenefitCard, { IBenefitCardProps } from './BenefitCard';
import SwiperButtonPrev from 'app/components/common/SwiperButtonPrev';
import SwiperButtonNext from 'app/components/common/SwiperButtonNext';
import styles from './BenefitSlider.module.scss';
import classNames from 'classnames';

export default function BenefitSlider({
  items
}: {
  items: IBenefitCardProps[];
}) {
  return (
    <Swiper spaceBetween={-12}>
      {items.map((item, index) => {
        return (
          <SwiperSlide key={index} className={classNames('px-3', styles.slide)}>
            <BenefitCard {...item} className="min-h-full" />
          </SwiperSlide>
        );
      })}
      <div className="flex gap-1 justify-end wrapper-main mt-3">
        <SwiperButtonPrev />
        <SwiperButtonNext />
      </div>
    </Swiper>
  );
}
